<template>
    <div>
      <SignaturePad
        :showSignaturePad="showSignaturePad"
        @close="showSignaturePad = false"
        @signatureData="signatureData"
      />
        <v-card min-height="40vh">
          <v-col
            cols="12"
            class="white--text text-uppercase text-center text-caption"
            style="background-color: #2b3990; "
            >{{ title }}
          </v-col>
          <v-col cols="12" md="12">
            <p class="text-caption">
              I, <b><span class="text-decoration-underline text-uppercase">{{
                  user.Name
                }}</span></b>, authorize a payroll deduction
              for the following training courses if I leave the company within six
              months of receiving the training:
            </p>

            <div class="ml-5">
              <v-row>
                <v-col cols="12" md="12">
                  <v-checkbox
                    class="text-caption"
                    v-model="chkSafety"
                    label="Safety Care $100 (upon hire and annually thereafter)"
                  ></v-checkbox>
                  <v-checkbox
                    class="text-caption"
                    v-model="chkPrevention"
                    label="CPR/First Aid/Choking Prevention $50 (upon hire and every two years thereafter)"
                  ></v-checkbox>
                  <v-checkbox
                    class="text-caption"
                    v-model="chkCertificate"
                    label="Medication Certification $350 (upon hire and every year thereafter)"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </div>

              <div class="ml-5">
                  <p class="text-caption">
                    <b>I further understand the following</b>
                      <ul>
                        <li>Employees must register for each training course in advance </li>
                        <li>Employees will be paid for the time spent in each training course offered by {{ userCompany }}</li>
                        <li>Employees will not be charged for each training course until the course has been taken. </li>
                        <li>Employees who do not show up for a training course or who do not provide a 24-hour notice  of cancellation will be charged the cost of the training course. </li>
                        <li>Employees can opt out of the CPR/First Aid/Choking Prevention training course provided by  {{ userCompany }} if they have completed (or will complete) an  approved, in-person CPR/First  Aid/Choking Prevention training course at another facility.</li>
                        <li>Employees will not be paid for time spent in a CPR/First Aid/Choking Prevention training  course at another facility. </li>
                      </ul>
                  </p>
              </div>

          </v-col>
             <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="item.employeeName"
                  label="Employee Name (print)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <div style="position: relative">
                  <v-text-field
                    label="Employee's Signature"
                    @click.stop="showSignaturePad = true"
                  ></v-text-field>
                  <v-img
                    width="150"
                    height="50"
                    :src="employeeSignature"
                    style="position:absolute;top:10px;right:150px;"
                  ></v-img>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <v-menu
                  ref="menu"
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="item.signedDate"
                      label="Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    v-model="item.signedDate"
                    @input="dateMenu = false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-row align="center" justify="start">
                  <v-card-actions>
                    <v-btn color="" @click="prev">Prev</v-btn>
                  </v-card-actions>
                </v-row>
              </v-col>

              <v-col>
                <v-row align="center" justify="end">
                  <v-card-actions>
                      <v-btn @click="next">Next</v-btn>
                  </v-card-actions>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-card>

    </div>
  </template>
  <script>

  /* eslint-disable */
  import { mapGetters, mapActions } from "vuex";
  import SignaturePad from "@/components/SignaturePad";
  import moment from "moment";
  import download from "downloadjs";

  export default {
    components: {SignaturePad},
    props: {
      title: {
        type: String,
        default: "",
      },
      user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
    },
    data: function() {
      return {
        dateMenu: false,
        item: {},
        step: this.currentStep,
        employeeSignature: "",
        showSignaturePad: false,
        chkCertificate: "",
        chkPrevention: "",
        chkSafety:"",
      };
    },

    created() {
      this.populateUserInfo()
    },

    computed: {
      ...mapGetters("userDocuments", ["getUserDocuments"]),
      ...mapGetters("users", {
        user: "user",
        userCompany: "userCompany",
      }),
    },

    methods: {
      ...mapActions({
        getDocuments: "userDocuments/getDocuments",
        addTransportationDoc: "userDocuments/saveTransportationDocument",
        addDocument: "userDocuments/updateDocument",
        downloadDocuments: "userDocuments/downloadDocuments",
      }),

      signatureData(data) {
        this.employeeSignature = data;
      },

      next() {
      this.addItem();
      // this.generatePDF();
      this.$emit("clicked", this.step + 1);
      },

      prev() {
        this.$emit("clicked",  this.step - 1);
      },

      populateUserInfo() {
      this.item.employeeName = this.user.Name;
    },

    async addItem() {
      try {
        const response = await this.addDocument({
          data: { ...this.item, Employee: this.user._id },
          pdfDocument: "training-fee-deducation-authorization",
        });
        console.log(response);
        localStorage.setItem('chkCertificate', this.chkCertificate);
        localStorage.setItem('chkPrevention', this.chkPrevention);
        localStorage.setItem('chkSafety', this.chkSafety);
      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {

      const dateSigned = localStorage.getItem('dateSignedInTraining');
      const checkCertificate = localStorage.getItem('chkCertificate');
      const checkPrevention = localStorage.getItem('chkPrevention');
      const checkSafety = localStorage.getItem('chkSafety');

      if (dateSigned !== null) {
         this.item.dateSignedInTraining= dateSigned;
      }
      if (checkCertificate !== null) {
         this.chkCertificate= checkCertificate;
      }
      if (checkPrevention !== null) {
         this.chkPrevention= checkPrevention;
      }
      if (checkSafety !== null) {
         this.chkSafety= checkSafety;
      }


      this.item.employeeName = this.user.Name;

      const response = await this.getDocuments(this.user._id);

      let documents = this.updateCase(
        response.data.document.Documents.TrainingFeeDeductionAuthorization
      );

      this.item = Object.assign(
        {},
        {
          ...documents,
          employeeName: response.data.document.Employee.Name,
        }
      );
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "training-fee-deducation-authorization",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(
        pdfFile,
        "training-fee-deducation-authorization.pdf",
        "application/pdf"
      );
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
     },
    },
  };
  </script>
  <style scoped>
  .theme--light.v-btn.v-btn--has-bg {
    background-color: #2b3990;
    color: #fff;
    border-radius: 1.25rem;
  }

  .v-input--checkbox .v-label {
      font-size: 100px;
    }
  </style>
